import React, { useEffect, useRef, useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import Icon from "../../assets/icons/location-babyblue.svg"
import IconWhite from "../../assets/icons/location-white.svg"
import { navigate } from "gatsby"
import closeIcon from "../../assets/close.svg"
import closeIconWhite from "../../assets/close-white.svg"
import Fuse from "fuse.js"
import "./styles.scss"
import {
  SearchLocationInputSet,
  searchResultPagePath,
  SearchStatusUpdate,
} from "../../slices/searchSlice"
import useOverlay from "../../hooks/useOverlay"
import useEscapeBlur from "../../hooks/useEscapeBlur"
import useUpdateCSS from "../../hooks/useUpdateCSS"

export const dispatchNewLocation = (address, locations, source, dispatch) => {
  const { location } =
    locations.find(item => item.location_address === address) || {}
  if (location?.lat) {
    dispatch(
      SearchLocationInputSet({
        source,
        lng: location.lon,
        lat: location.lat,
      })
    )
  }
}

const SearchInputServiceLocations = ({ type, setFocus }) => {
  const [value, setValue] = useState("")
  const [fuse, setFuse] = useState()
  const [suggestions, setSuggestions] = useState([])
  const inputRef = useRef(null)
  const { isFocused, overlayRef } = useOverlay(inputRef)
  const { serviceLocations, serviceLocationsWithGeo } = useSelector(
    state => state.searching
  )
  const onInputFocus = () => {
    dispatch(SearchStatusUpdate({ status: "focus" }))
  }
  //
  const onInputBlur = () => {
    setTimeout(() => {
      dispatch(SearchStatusUpdate({ status: "idle" }))
      setSuggestions([])
    }, 500)
  }
  const dispatch = useDispatch()

  useEscapeBlur(inputRef)
  useUpdateCSS(isFocused, ".sticky-header", "searchInput__focused")

  const onClickItem = address => {
    setSuggestions([])
    setValue("")
    dispatchNewLocation(
      address,
      serviceLocationsWithGeo,
      "SEARCH_INPUT",
      dispatch
    )
    navigate(searchResultPagePath(address))
  }

  useEffect(() => {
    const options = {
      includeScore: true,
      findAllMatches: true,
    }

    if (serviceLocations.length) {
      setFuse(new Fuse(serviceLocations, options))
    }
  }, [serviceLocations])

  useEffect(() => {
    if (fuse) {
      const result = fuse.search(value)
      setSuggestions(result)
    }
  }, [value])

  useEffect(() => {
    if (setFocus) {
      setTimeout(() => {
        inputRef.current.focus()
      }, 100)
    }
  }, [setFocus])

  return (
    <div>
      <div
        className={`searchInput ${
          type === "HERO" ? "searchInput__hero" : "searchInput__page"
        }`}
      >
        <input
          ref={inputRef}
          value={value}
          onFocus={onInputFocus}
          onBlur={onInputBlur}
          onChange={e => setValue(e.target.value)}
          placeholder={"Enter a location"}
          className={"searchInput__input"}
        />
        <img
          src={type == "HERO" ? IconWhite : Icon}
          alt="search-icon"
          className="searchInput__leftIcon"
          width={35}
        />

        {value?.length ? (
          <img
            onClick={() => {
              setSuggestions([])
              setValue("")
            }}
            type={"button"}
            src={type == "HERO" ? closeIconWhite : closeIcon}
            alt="Location search cancel button"
            className="searchInput__cancel"
          />
        ) : (
          <div
            onClick={() => {
              inputRef.current.focus()
            }}
            className="searchInput__searchButton"
          >
            Search
          </div>
        )}
        <div className={suggestions?.length > 0 ? "searchInput__result" : ""}>
          {suggestions?.map((item, i) => {
            return (
              <div
                key={i}
                className={"dropdownmenu-item"}
                style={{
                  backgroundColor: item?.active ? "#fafafa" : "#ffffff",
                  cursor: "pointer",
                }}
                onClick={() => onClickItem(item?.item)}
              >
                <span>{item?.item}</span>
              </div>
            )
          })}
        </div>
      </div>
      <div
        className={`overlay ${isFocused ? "visible" : "hidden"}`}
        ref={overlayRef}
      />
    </div>
  )
}

export default SearchInputServiceLocations
